//import * as icv from './icv';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';
import * as _ht from './_ht';
import * as ihd from './ihd';

export const grtPzForSaveI1zrDz = (uz: _ht.uz, pz: {
  i1zz: _ht.dz,
  i10rs: _ht.ls, // 部屋
  i17rs: _ht.ls, // 備品・駐車場
  i15rs: _ht.ls, // 団体種別
  i18rz: _ht.dz, // 団体
  hdys: _ht.ls, // 祝日
}) => {

//_hm.l(`ihdI1z 16a: ${_hm.s(pz.i1zz.i1zrz)}`);
//pz.i1zz.i1z1s.map((_i1z1z: _ht.dz) => {
//  _hm.l(`ihdI1z 16b: ${_hm.s(_i1z1z)}`);
//});

  /** @note 不要な i1z1s を削除 */
  pz.i1zz.i1z1s = pz.i1zz.i1z1s.filter((_i1z1z: _ht.dz) => _hm.f(_i1z1z) && _i1z1z._dlt != 1);
  //_hm.l(`ihdI1z 23a: ` + _hm.s(pz.i1zz.i1z1s));

  /** @note 時間帯種別の設定 */
  const _i18ri15r1f = pz.i18rz.i18ri15r1f ?? -1;
  const _i15rz = _hm.getDz(pz.i15rs, _i18ri15r1f, '_fst');
  const _i1z1t1100i = _i15rz?.i15ra6100i ?? 1;

  pz.i1zz.i1z1s
  .map((_i1z1z: _ht.dz) => {
    //_hm.l(`ihdI1z 21: ${_i1z1z.i1z1i10r1f},  ${_hm.s(_i1z1z)}`);
    _i1z1z.i1z1t1100i = _i1z1t1100i; // 時間帯種別
    if (!_i1z1z.crlz) _i1z1z.crlz = {};
    _i1z1z.i1z1d1100s = pz.i1zz.i1zrz.i1zrd3100s; // 時間帯分類用利用日 優先して更新
    //_hm.l(`ihdI1z 11a: ${_hm.s(_i1z1z)}`);
    const _i10rz = _hm.getDz(pz.i10rs, _i1z1z.i1z1i10r1f, '_fst'); // 部屋
    //_hm.l(`ihdI1z 11b: ${_hm.s(_i10rz)}`);
    const _i11rz = _hm.get1(_i10rz?.cldz?.i11rs); // 時間帯区分
    //_hm.l(`ihdI1z 11c: ${_hm.s(_i11rz)}`);
    const _i111z = _hm.getDz(_i11rz?.cldz?.i111s, _i1z1z.i1z1i1111f, '_fst'); // 時間帯
    //_hm.l(`ihdI1z 11d: ${_hm.s(_i111z)}`);
    const _i101z = _hm.get1(_i111z?.cldz?.i101z); // 利用料
    //_hm.l(`ihdI1z 11e: ${_hm.s(_i101z)}`);
    //_hm.l(`ihdI1z 11c: ${_hm.s(_i11rz)}`);
    _i1z1z.crlz.i10rz = _i10rz;
    _i1z1z.crlz.i11rz = _i11rz; // 時間帯区分
    _i1z1z.crlz.i111z = _i111z; // 時間帯
    _i1z1z.crlz.i101z = _i101z; 

    _i1z1z.i1z1d2100i = _i11rz.i11ra1100i; // 夏時間開始月
    _i1z1z.i1z1d2200i = _i11rz.i11ra1200i; // 夏時間終了月

    const _mth = _hmDTM.cvtMth(_i1z1z.i1z1d1100s);
    _i1z1z.i1z1c1100i = (_mth >= _i1z1z.i1z1d2100i && _mth <= _i1z1z.i1z1d2200i) ? 1 : -1; // 夏区分

    //_hm.l(`ihdI1z 45: ${_i1z1z.i1z1d1100s}, ${_hm.s(pz.hdys)}`);
    _i1z1z.i1z1c2100i = _hm.i(_i1z1z.i1z1d1100s, pz.hdys) ? 1 : -1; // 祝日区分

    const _dow = _hmDTM.cvtDow(_i1z1z.i1z1d1100s);
    _i1z1z.i1z1c3100i = 
      (_i1z1z.i1z1c2100i == 1 || _dow == '日') ? 
        30
      : _dow == '土' ?
        20
      : 10; // 曜日区分

    _i1z1z.i1z1c4100i = 
      _i1z1z.i1z1t1100i == 1 && _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 10 ?
        111
      : _i1z1z.i1z1t1100i == 1 && _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 20 ?
        112
      : _i1z1z.i1z1t1100i == 1 && _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 30 ?
        113
      : _i1z1z.i1z1t1100i == 1 && _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 10 ?
        121
      : _i1z1z.i1z1t1100i == 1 && _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 20 ?
        122
      : _i1z1z.i1z1t1100i == 1 && _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 30 ?
        123
      : _i1z1z.i1z1t1100i == 2 && _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 10 ?
        211
      : _i1z1z.i1z1t1100i == 2 && _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 20 ?
        212
      : _i1z1z.i1z1t1100i == 2 && _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 30 ?
        213
      : _i1z1z.i1z1t1100i == 2 && _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 10 ?
        221
      : _i1z1z.i1z1t1100i == 2 && _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 20 ?
        222
      : _i1z1z.i1z1t1100i == 2 && _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 30 ?
        223
      : -1; // 時間帯分類

    _i1z1z.i1z1a1100i = 
      _i1z1z.i1z1i1111f == -999 ?
        _i1z1z.i1z1a1100i
      : _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 10 ?
        _i111z?.i111a1111i
      : _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 20 ?
        _i111z?.i111a1112i
      : _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 30 ?
        _i111z?.i111a1113i
      : _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 10 ?
        _i111z?.i111a1121i
      : _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 20 ?
        _i111z?.i111a1122i
      : _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 30 ?
        _i111z?.i111a1123i
      : 0; // 開始時刻

    //_hm.l(`ihdI1z 106: ${_i1z1z.i1z1c1100i}, ${_i1z1z.i1z1c3100i}, ${_i1z1z.i1z1a1100i}, ${_hm.s(_i111z)}`);

    _i1z1z.i1z1a1200i = 
      _i1z1z.i1z1i1111f == -999 ?
        _i1z1z.i1z1a1200i
      : _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 10 ?
        _i111z?.i111a2111i
      : _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 20 ?
        _i111z?.i111a2112i
      : _i1z1z.i1z1c1100i == -1 && _i1z1z.i1z1c3100i == 30 ?
        _i111z?.i111a2113i
      : _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 10 ?
        _i111z?.i111a2121i
      : _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 20 ?
        _i111z?.i111a2122i
      : _i1z1z.i1z1c1100i ==  1 && _i1z1z.i1z1c3100i == 30 ?
        _i111z?.i111a2123i
      : 0; // 終了時刻

  });
  //_hm.l(`ihdI1z 23b: ` + _hm.s(pz.i1zz.i1z1s));

  /** @note 部屋表示名・部屋表示順の更新 */
  let _i1zra1110s = ''; // 部屋表示順
  const _i10r_pfxs = [] as _ht.ls;
  pz.i1zz.i1z1s
  .filter((_i1z1z: _ht.dz) => _hm.f(_i1z1z.crlz.i10rz?._pfx))
  .sort((_i1z1z1: _ht.dz, _i1z1z2: _ht.dz) => {
    if (_i1z1z1.crlz.i10rz._icn > _i1z1z2.crlz.i10rz._icn) return  1;
    if (_i1z1z1.crlz.i10rz._icn < _i1z1z2.crlz.i10rz._icn) return -1;
    return 0;
  }).map((_i1z1z: _ht.dz) => {
    //_i1zra1100s += ((_i1zra1100s == '') ? '' : '・') + _i1z1z.crlz.i10rz._pfx;
    if (_hm.i(_i1z1z.crlz.i10rz._pfx, _i10r_pfxs) == false) _i10r_pfxs.push(_i1z1z.crlz.i10rz._pfx);
    if (_i1zra1110s == '') _i1zra1110s = _i1z1z.crlz.i10rz._icn;
  });
  pz.i1zz.i1zrz.i1zra1100s = _i10r_pfxs.join('・'); // 部屋表示名
  pz.i1zz.i1zrz.i1zra1110s = _i1zra1110s; // 部屋表示順
  //_hm.l(`ihdI1z 23c: ` + _hm.s(pz.i1zz.i1z1s));

  /** @note 時間帯表示名・時間帯表示順の更新 */
  let _i1zra1200s = ''; // 時間帯表示名
  let _i1zra1210s = ''; // 時間帯表示順
  const _i111_pfxs = [] as _ht.ls;
  pz.i1zz.i1z1s
  .sort((_i1z1z1: _ht.dz, _i1z1z2: _ht.dz) => {
    if (_i1z1z1.i1z1i1111f == -999 && _i1z1z2.i1z1i1111f == -999) return  0;
    if (_i1z1z1.i1z1i1111f == -999 && _i1z1z2.i1z1i1111f != -999) return -2;
    if (_i1z1z1.i1z1i1111f != -999 && _i1z1z2.i1z1i1111f == -999) return  2;
    if (_i1z1z1.crlz.i111z._icn > _i1z1z2.crlz.i111z._icn) return  1;
    if (_i1z1z1.crlz.i111z._icn < _i1z1z2.crlz.i111z._icn) return -1;
    return 0;
  }).map((_i1z1z: _ht.dz) => {
// _hm.l(`ihdI1z 162a: ${_i1z1z.i1z1i1111f}`);
// _hm.l(`ihdI1z 162b: ${_hm.s(_i1z1z.crlz.i111z)}`);
// _hm.l(`ihdI1z 162c: ${_hm.s(_i1z1z)}`);
    if (_i1z1z.i1z1i1111f == -999) {
      //_i1zra1200s += ((_i1zra1200s == '') ? '' : '・') + 'その他１時間';
      if (_hm.i('その他１時間', _i111_pfxs) == false) _i111_pfxs.push('その他１時間');
      if (_i1zra1210s == '') _i1zra1210s = '999999999';
    }
    else {
//      _i1zra1200s += ((_i1zra1200s == '') ? '' : '・') + _i1z1z.crlz.i111z._pfx;
      if (_hm.i(_i1z1z.crlz.i111z._pfx, _i111_pfxs) == false) _i111_pfxs.push(_i1z1z.crlz.i111z._pfx);
      if (_i1zra1210s == '') _i1zra1210s = _i1z1z.crlz.i111z._icn;
    }
  });
  pz.i1zz.i1zrz.i1zra1200s = _i111_pfxs.join('・'); // 時間帯表示名
  pz.i1zz.i1zrz.i1zra1210s = _i1zra1210s; // 時間帯表示順

  pz.i1zz.i1z2s.map((_i1z2z: _ht.dz) => {
    if (!_i1z2z.crlz) _i1z2z.crlz = {};
    const _i17rz = _hm.getDz(pz.i17rs, _i1z2z.i1z2i17r1f, '_fst');
    _i1z2z.crlz.i17rz = _i17rz;
  });
  //_hm.l(`ihdI1z 23d: ` + _hm.s(pz.i1zz.i1z1s));

  /** @note 備品・駐車場の表示名の更新 */
  //let _i1zra1300s = ''; // 備品・駐車場表示名
  const _i17r_pfxs = [] as _ht.ls;
  pz.i1zz.i1z2s
  .filter((_i1z2z: _ht.dz) => _hm.f(_i1z2z.crlz.i17rz?._pfx))
  .sort((_i1z2z1: _ht.dz, _i1z2z2: _ht.dz) => {
    if (_i1z2z1.crlz.i17rz._icn > _i1z2z2.crlz.i17rz._icn) return  1;
    if (_i1z2z1.crlz.i17rz._icn < _i1z2z2.crlz.i17rz._icn) return -1;
    return 0;
  }).map((_i1z2z: _ht.dz) => {
//    _i1zra1300s += ((_i1zra1300s == '') ? '' : '・') + _i1z2z.crlz.i17rz._pfx;
    if (_hm.i(_i1z2z.crlz.i17rz._pfx, _i17r_pfxs) == false) _i17r_pfxs.push(_i1z2z.crlz.i17rz._pfx);
  });
  pz.i1zz.i1zrz.i1zra1300s = _i17r_pfxs.join('・'); // 備品・駐車場表示名
  //_hm.l(`ihdI1z 23e: ` + _hm.s(pz.i1zz.i1z1s));

  const _atrs = [] as _ht.ls;
  //pz.i10rs.map((i10rz: _ht.dz) => {
  //  _hm.l(`ihdI1z 209a: ${i10rz._fst}, ${_hm.s({ ... i10rz, cldz: undefined })}`)
  //})
  pz.i1zz.i1z1s.map((_i1z1z: _ht.dz) => {
    _i1z1z.crlz.i10rz.crlz.i10r_fstsSglAll.map((_i10r_fst: _ht.n) => { // i1z1z に関わる単体部屋
      const _i10rz2 = _hm.getDz(pz.i10rs, _i10r_fst, '_fst');
      //_hm.l(`ihdI1z 209b: ${_i10r_fst}, ${_hm.s(_i10rz2)}`)
      /** @note 予約状況業の追加 */
      if (_i1z1z.i1z1i1111f != -999) { // その他時間を除く
        _atrs.push({ qry: `
          INSERT INTO
            i1z5s
          (
            _dmn,
            i1z5_31r1f,
            i1z5i10r1f,
            i1z5d1100s,
            i1z5i1111f,
            i1z5d2100i, -- 夏時間開始月 
            i1z5d2200i, -- 夏時間終了月
            i1z5c1100i, -- 夏区分
            i1z5c2100i, -- 祝日区分
            i1z5c3100i, -- 曜日区分
            i1z5d3100i, -- 開始時刻
            i1z5d3200i, -- 終了時刻
            "createdAt",
            "updatedAt"
          ) VALUES (
            ${uz._dmn},
            ${pz.i1zz.i1zrz.i1zr_31r1f},
            ${_i10rz2?._fst},
            '${_i1z1z.i1z1d1100s}',
            ${_i1z1z.i1z1i1111f},
            ${_i1z1z.i1z1d2100i},
            ${_i1z1z.i1z1d2200i},
            ${_i1z1z.i1z1c1100i},
            ${_i1z1z.i1z1c2100i},
            ${_i1z1z.i1z1c3100i},
            ${_i1z1z.i1z1a1100i},
            ${_i1z1z.i1z1a1200i},
            now(),
            now()
          )
          ON CONFLICT ON CONSTRAINT i1z5_unq1
          DO NOTHING
        ` });
      }

      /** @note 予約数の更新 */
      _atrs.push({ qry: `
        UPDATE
          i1z5s
        SET
          i1z5a1100i = (
            SELECT
              COUNT(*)
            FROM
              i1z1s LEFT JOIN i1zrs ON i1z1s.i1z1i1zr1k = i1zrs._key
            WHERE
              COALESCE(i1zrs._dlt,-1)<>1
              AND i1zrs._vsn = i1zrs._ltt
              AND i1zrs.i1zr_31r1f = i1z5s.i1z5_31r1f
              AND i1zrs.i1zrd3100s = i1z5s.i1z5d1100s
              AND i1zrs.i1zrs1100i >= 70
              AND COALESCE(i1z1s._dlt,-1)<>1
              AND i1z1s.i1z1_31r1f = i1zrs.i1zr_31r1f
              AND i1z1s.i1z1d1100s = i1z5s.i1z5d1100s
              AND i1z1s.i1z1a1100i < i1z5s.i1z5d3200i
              AND i1z1s.i1z1a1200i > i1z5s.i1z5d3100i
              AND i1z1s.i1z1i10r1f IN (${_hm.join(_i10rz2?.crlz.i10r_fstsAll, ',')})
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s.i1z5_31r1f = ${pz.i1zz.i1zrz.i1zr_31r1f}
          AND i1z5s.i1z5d1100s = '${_i1z1z.i1z1d1100s}' -- 利用日が変わってない前提
          AND i1z5s.i1z5i10r1f IN (${_hm.join(_i10rz2?.crlz.i10r_fstsAll, ',')}) -- 部屋が変わってない前提
      ` });
//          -- AND i1z5s.i1z5i10r1f = ${_i10rz2?._fst} -- 部屋が変わってない前提

      /** @note エントリー数の更新 */
      _atrs.push({ qry: `
        UPDATE
          i1z5s
        SET
          i1z5a2100i = (
            SELECT
              COUNT(*)
            FROM
              i1z1s LEFT JOIN i1zrs ON i1z1s.i1z1i1zr1k = i1zrs._key
            WHERE
              COALESCE(i1zrs._dlt,-1)<>1
              AND i1zrs._vsn = i1zrs._ltt
              AND i1zrs.i1zr_31r1f = i1z5s.i1z5_31r1f
              AND i1zrs.i1zrd3100s = i1z5s.i1z5d1100s
              AND i1zrs.i1zrs1200i >= 70
              AND COALESCE(i1z1s._dlt,-1)<>1
              AND i1z1s.i1z1_31r1f = i1zrs.i1zr_31r1f
              AND i1z1s.i1z1d1100s = i1z5s.i1z5d1100s
              AND i1z1s.i1z1a1100i < i1z5s.i1z5d3200i
              AND i1z1s.i1z1a1200i > i1z5s.i1z5d3100i
              AND i1z1s.i1z1i10r1f IN (${_hm.join(_i10rz2?.crlz.i10r_fstsAll, ',')})
          )
        WHERE
          COALESCE(i1z5s._dlt,-1)<>1
          AND i1z5s.i1z5_31r1f = ${pz.i1zz.i1zrz.i1zr_31r1f}
          AND i1z5s.i1z5d1100s = '${_i1z1z.i1z1d1100s}' -- 利用日が変わってない前提
          AND i1z5s.i1z5i10r1f IN (${_hm.join(_i10rz2?.crlz.i10r_fstsAll, ',')}) -- 部屋が変わってない前提
      ` });
//          -- AND i1z5s.i1z5i10r1f = ${_i10rz2?._fst} -- 部屋が変わってない前提
    })
  });

//_hm.l(`ihdI1z 294a: ${_hm.s(pz.i1zz.i1zrz)}`);
//pz.i1zz.i1z1s.map((_i1z1z: _ht.dz) => {
//  _hm.l(`ihdI1z 294b: ${_hm.s(_i1z1z)}`);
//});

  return {
    tgt: 'i1zrs',
    dz: {
      ... pz.i1zz.i1zrz,
      ... uz,
      },
    lwrz: 
      pz.i1zz.i1zrz._dlt != 1 ?
      {
        i1z1s: {
          tgt: 'i1z1s',
          ls: 
            pz.i1zz.i1z1s?.filter((_i1z1z: _ht.dz) => _hm.f(_i1z1z) && _i1z1z._dlt != 1),
          udtz: {
            i1z1_31r1f: 'i1zrs.i1zr_31r1f',
            i1z1i1zr1k: 'i1zrs._key',
          }
        },
        i1z2s: {
          tgt: 'i1z2s',
          ls: pz.i1zz.i1z2s?.filter((_i1z2z: _ht.dz) => _hm.f(_i1z2z) && _i1z2z._dlt != 1),
          udtz: {
            i1z2_31r1f: 'i1zrs.i1zr_31r1f',
            i1z2i1zr1k: 'i1zrs._key',
          },
/*
          lwrz: { // 不要？
            i17rs: {
              tgt: 'i17rs',
              cdn: f.vdd() + ` AND _fst = {i1z2i17r1f}`,
              rlcz: {
                i1z2i17r1f: `i1z2s.i1z2i17r1f`,
              }
            }
          }
*/
        },
        i1z3s: {
          tgt: 'i1z3s',
          ls: [pz.i1zz.i1z3z],
          udtz: {
            i1z3_31r1f: 'i1zrs.i1zr_31r1f',
            i1z3i1zr1k: 'i1zrs._key',
          }
        },
        i1z4s: {
          tgt: 'i1z4s',
          ls: [pz.i1zz.i1z4z],
          udtz: {
            i1z4_31r1f: 'i1zrs.i1zr_31r1f',
            i1z4i1zr1k: 'i1zrs._key',
          }
        },
      }
      : undefined,
    atrs: [
      ... ihd.f('_icn', 'i1zr').atrs, // 予約ID
      ... _atrs,
    ]
  };
};

export const i1zz = {
  i1zr: {
    // 利用情報
    v0: {
      itlz: {
        i1zr_31r1f: -1,
        i1zri18r1f: -1,
        i1zrs1100i: 0,
        i1zrs1200i: 0,
        //        i1zrs2100i: -1,
        i1zrt1100i: -1,
        i1zrd1100s: "",
        i1zrd2100s: "",
        i1zrd3100s: "",
        i1zra1100s: "",
        i1zra1200s: "",
        i1zra2100s: "",
        i1zra3100s: "",
        i1zra4100s: "",
        i1zra5100s: "",
        i1zra6100i: -1,
        i1zra7100s: "0", // 新規登録
      },
      fldz: {
        _icn: {
          atrs: [
            {
              qry: `
                UPDATE
                  i1zrs
                SET
                  _icn = (
                    SELECT
                      to_char(COUNT(A.*), 'fm000000')
                    FROM
                      i1zrs AS A
                    WHERE
                      A._vsn = A._ltt AND A._dmn = i1zrs._dmn
                      AND A._key <= i1zrs._key
                  )
                WHERE
                  _key = {i1zr_key}
                  AND COALESCE(_icn,'') = ''
                `, // delete を 含むこと
              rlcz: {
                i1zr_key: "i1zrs._key",
              },
            },
          ],
        },
        i1zr_31r1f: {
          pfx: "所属組織",
        },
        i1zri18r1f: {
          pfx: "団体",
        },
        i1zri11r1f: {
          pfx: "時間帯区分",
        },
        i1zrd1100s: {
          pfx: "登録日",
        },
        i1zrd2100s: {
          pfx: "申込日",
        },
        i1zrd3100s: {
          pfx: "利用日",
        },
        i1zrd4100i: {
          pfx: "開始時刻",
        },
        i1zrd4200i: {
          pfx: "終了時刻",
        },
        i1zrs1100i: {
          pfx: "予約状況",
          ls: [
            { key: -1, pfx: " " },
            { key: 10, pfx: "予約なし" },
            { key: 20, pfx: "キャンセル" }, // 便宜上
            { key: 22, pfx: "仮予約キャンセル" },
            { key: 24, pfx: "返金ありキャンセル" },
            { key: 26, pfx: "返金なしキャンセル" },
            { key: 60, pfx: "落選" },
            { key: 70, pfx: "仮押" },
            { key: 80, pfx: "仮予約" },
            { key: 90, pfx: "本予約" },
          ],
        },
        i1zrs1200i: {
          pfx: "エントリー状況",
          ls: [
            { key: -1, pfx: " " },
            { key: 10, pfx: "エントリーなし" },
            { key: 20, pfx: "キャンセル済" },
            { key: 60, pfx: "未エントリー" },
            { key: 70, pfx: "エントリー済" },
            { key: 80, pfx: "落選" },
            { key: 90, pfx: "当選" },
          ],
        },
        i1zrt1100i: {
          pfx: "優先利用",
          ls: [
            { key: -1, pfx: "なし" },
            { key: 1, pfx: "あり" },
          ],
        },
        i1zra1100s: {
          pfx: "部屋表示",
/*
          atrs: [
            {
              qry: `
                UPDATE
                  i1zrs
                SET
                  i1zra1100s = ARRAY_TO_STRING(
                    ARRAY(
                      SELECT 
                        c._pfx 
                      FROM 
                        i10rs AS c
                      WHERE 
                        c._vsn = c._ltt
                        AND c._fst IN (
                          SELECT
                            b.i1z1i10r1f
                          FROM
                            i1z1s AS b
                          WHERE
                            coalesce(b._dlt,-1)<>1 and
                            b._vsn = b._ltt and
                            b.i1z1i1zr1k = i1zrs._key
                        )
                      ORDER BY
                        c._icn
                    ), 
                    '・'
                  ),
                  i1zra1110s = (
                    SELECT 
                      c._icn
                    FROM 
                      i10rs AS c
                    WHERE 
                      c._vsn = c._ltt
                      AND c._fst IN (
                        SELECT
                          b.i1z1i10r1f
                        FROM
                          i1z1s AS b
                        WHERE
                          coalesce(b._dlt,-1)<>1 and
                          b._vsn = b._ltt and
                          b.i1z1i1zr1k = i1zrs._key
                      )
                    ORDER BY
                      c._icn
                    OFFSET 0 LIMIT 1
                  )
                WHERE
                  _key = {i1zr_key}
                `,
              rlcz: {
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
        i1zra1110s: {
          pfx: "部屋表示順",
/*
          atrs: [
            {
              qry: `
                UPDATE
                  i1zrs
                SET
                  i1zra1110s = (
                    SELECT 
                      c._icn
                    FROM 
                      i10rs AS c
                    WHERE 
                      c._vsn = C._ltt
                      AND c._fst IN (
                        SELECT
                          b.i1z1i10r1f
                        FROM
                          i1z1s AS b
                        WHERE
                          coalesce(b._dlt,-1)<>1 and
                          b._vsn = b._ltt and
                          b.i1z1i1zr1k = i1zrs._key
                      )
                    ORDER BY
                      c._icn
                    OFFSET 0 LIMIT 1
                  )
                WHERE
                  _key = {i1zr_key}
                `,
              rlcz: {
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
        i1zra1200s: {
          pfx: "時間帯表示",
/*
          atrs: [
            {
              qry: `
                UPDATE
                  i1zrs
                SET
                  i1zra1200s = ARRAY_TO_STRING(
                    ARRAY(
                      SELECT 
                        CASE
                          WHEN
                            b.i1z1i1111f = -999
                          THEN
                            'その他１時間'
                          ELSE
                            c._pfx 
                        END
                      FROM 
                        i1z1s AS b
                        LEFT JOIN i111s AS c ON c._fst = b.i1z1i1111f AND COALESCE(c._dlt,-1) <> 1 AND c._vsn = c._ltt
                      WHERE 
                        COALESCE(b._dlt,-1) <> 1 and b._vsn = b._ltt 
                        AND b.i1z1i1zr1k = i1zrs._key
                      ORDER BY
                        c._icn::NUMERIC::INTEGER
                    ), 
                    '・'
                  ),
                  i1zra1210s = (
                    SELECT 
                      c._icn
                    FROM 
                      i1z1s AS b
                      LEFT JOIN i111s AS c ON c._fst = b.i1z1i1111f AND COALESCE(c._dlt,-1) <> 1 AND c._vsn = c._ltt
                    WHERE 
                      COALESCE(b._dlt,-1) <> 1 and b._vsn = b._ltt 
                      AND b.i1z1i1zr1k = i1zrs._key
                    ORDER BY
                      c._icn::NUMERIC::INTEGER
                    OFFSET 0 LIMIT 1
                  )
                WHERE
                  _key = {i1zr_key}
                `,
              rlcz: {
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
        i1zra1210s: {
          pfx: "時間帯表示順",
        },
        i1zra1300s: {
          pfx: "備品・駐車場表示",
/*
          atrs: [
            {
              qry: `
                UPDATE
                  i1zrs
                SET
                  i1zra1300s = ARRAY_TO_STRING(
                    ARRAY(
                      SELECT 
                        _pfx 
                      FROM 
                        i17rs
                      WHERE 
                        COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                        AND _fst IN (
                          SELECT
                            i1z2i17r1f
                          FROM
                            i1z2s
                          WHERE
                            COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                            AND i1z2i1zr1k = i1zrs._key
                        )
                      ORDER BY
                        _icn
                    ), 
                    '・'
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1 AND _dmn={i1zr_dmn}
                  AND i1zr_31r1f={i1zr_31r1f}
                  AND _key = {i1zr_key}
                `,
              rlcz: {
                i1zr_dmn: "i1zrs._dmn",
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },

        i1zra2100s: {
          pfx: "申込者",
        },
        i1zra3100s: {
          pfx: "連絡先電話番号",
        },
        i1zra4100s: {
          pfx: "目的",
        },
        i1zra5100s: {
          pfx: "内部メモ",
        },
        i1zra6100i: {
          pfx: "経路",
          ls: [
            { key: -1, pfx: "WEB" },
            { key: 1, pfx: "窓口" },
          ],
        },
        i1zra7100s: {
          pfx: "外部連携予約ID", // i1z1a3100s から変更
        },
        i1zra8100s: {
          pfx: "団体からの伝達事項",
        },
      },
    },
  },
  i1z1: {
    // 利用部屋
    v0: {
      itlz: {
        i1z1_31r1f: -1,
        i1z1i1zr1k: -1,
        i1z1i10r1f: -1,
        i1z1i1111f: -1,
        i1z1m1100i: 0,
        i1z1a1100i: 0,
        i1z1a1200i: 0,
        i1z1a2100s: "",
        i1z1a2200s: "",
        i1z1a3100s: "0", // '0': 新規登録
        _dlt: -1,
      },
      fldz: {
        i1z1_31r1f: {
          pfx: "施設",
        },
        i1z1i1zr1k: {
          pfx: "利用情報",
        },
        i1z1i10r1f: {
          pfx: "部屋",
        },
        i1z1i1111f: {
          pfx: "時間帯",
        },
        i1z1m1100i: {
          pfx: "利用料",
        },
        i1z1m1120i: {
          pfx: "利用料（検証用）",
        },
        i1z1a1100i: {
          pfx: "開始時刻",
          ls: [
            { key: 5, pfx: "5時" },
            { key: 6, pfx: "6時" },
            { key: 7, pfx: "7時" },
            { key: 8, pfx: "8時" },
            { key: 9, pfx: "9時" },
            { key: 10, pfx: "10時" },
            { key: 11, pfx: "11時" },
            { key: 12, pfx: "12時" },
            { key: 13, pfx: "13時" },
            { key: 14, pfx: "14時" },
            { key: 15, pfx: "15時" },
            { key: 16, pfx: "16時" },
            { key: 17, pfx: "17時" },
            { key: 18, pfx: "18時" },
            { key: 19, pfx: "19時" },
            { key: 20, pfx: "20時" },
            { key: 21, pfx: "21時" },
            { key: 22, pfx: "22時" },
            { key: 23, pfx: "23時" },
            { key: 0, pfx: "0時" },
            { key: 1, pfx: "1時" },
            { key: 2, pfx: "2時" },
            { key: 3, pfx: "3時" },
            { key: 4, pfx: "4時" },
          ],
        },
        i1z1a1200i: {
          pfx: "終了時刻",
        },
        i1z1a2100s: {
          pfx: "部屋表記",
        },
        i1z1a2200s: {
          pfx: "時間帯表記",
        },
        i1z1a3100s: {
          pfx: "外部連携予約ID", // i1zra7100s へ変更
        },
        i1z1t1100i: {
          pfx: "時間帯種別",
/*
          atrs: [
            {
              qry: `
                UPDATE
                  i1z1s
                SET
                  i1z1t1100i = (
                    SELECT
                      i15ra6100i
                    FROM
                      i15rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND _fst = (
                        SELECT
                          i18ri15r1f
                        FROM
                          i18rs
                        WHERE
                          COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                          AND _fst = (
                            SELECT
                              i1zri18r1f
                            FROM
                              i1zrs
                            WHERE
                              COALESCE(_dlt,-1)<>1
                              AND _key = i1z1i1zr1k
                          )
                      )
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1 AND i1z1_31r1f = {i1zr_31r1f}
                  AND i1z1i1zr1k = {i1zr_key}
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
        i1z1d1100s: {
          pfx: "利用日",
/*
          atrs: [
            {
              // 利用日の設定 // 他の処理より優先して実行
              qry: `
                UPDATE
                  i1z1s
                SET
                  i1z1d1100s = (
                    SELECT
                      i1zrd3100s
                    FROM
                      i1zrs
                    WHERE
                      COALESCE(i1zrs._dlt,-1)<>1
                      AND _key = i1z1i1zr1k
                  )
                WHERE
                  COALESCE(i1z1s._dlt,-1)<>1 AND i1z1_31r1f = {i1zr_31r1f}
                  AND i1z1s.i1z1i1zr1k = {i1zr_key}
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
        i1z1d2100i: {
          pfx: "夏時間開始月",
/*
          atrs: [
            {
              // 夏時間開始月・終了月の設定（追加したもののみ）
              qry: `
                UPDATE
                  i1z1s
                SET
                  (i1z1d2100i, i1z1d2200i) = (
                    SELECT
                      COALESCE(i11ra1100i,0), COALESCE(i11ra1200i,0)
                    FROM
                      i11rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn = _ltt
                      AND _fst = (
                        SELECT
                          i1zri11r1f
                        FROM
                          i1zrs
                        WHERE
                          COALESCE(_dlt,-1)<>1
                          AND _key = i1z1i1zr1k
                      )
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1 AND i1z1_31r1f = {i1zr_31r1f}
                  AND i1z1i1zr1k = {i1zr_key}
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
        i1z1d2200i: {
          pfx: "夏時間終了月",
        },
        i1z1c1100i: {
          pfx: "夏区分",
          ls: [
            { key: 1, pfx: "対象" },
            { key: -1, pfx: "非対象" },
          ],
/*
          atrs: [
            {
              // 夏区分の設定（追加したもののみ）
              qry: `
                UPDATE
                  i1z1s
                SET
                  i1z1c1100i = (
                    SELECT
                      CASE
                        WHEN
                          SUBSTRING(i1z1d1100s, 6, 2)::NUMERIC >= i1z1d2100i
                          AND SUBSTRING(i1z1d1100s, 6, 2)::NUMERIC <= i1z1d2200i
                        THEN
                          1
                        ELSE
                          -1
                      END
                  )
                WHERE
                  COALESCE(i1z1s._dlt,-1)<>1 AND i1z1_31r1f = {i1zr_31r1f}
                  AND i1z1s.i1z1i1zr1k = {i1zr_key}
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
        i1z1c2100i: {
          pfx: "祝日区分",
          ls: [
            { key: 1, pfx: "対象" },
            { key: -1, pfx: "非対象" },
          ],
/*
          atrs: [
            {
              // 曜日の設定　＃祝日区分（追加したもののみ）
              qry: `
                UPDATE
                  i1z1s
                SET
                  i1z1c2100i = (
                    SELECT
                      CASE
                        WHEN
                          EXISTS(
                            SELECT
                              *
                            FROM
                              _601s
                            WHERE
                              COALESCE(_601s._dlt,-1)<>1
                              AND _601s._icn = i1z1s.i1z1d1100s
                          )
                        THEN
                          1
                        ELSE
                          -1
                      END
                  )
                WHERE
                  COALESCE(i1z1s._dlt,-1)<>1 AND i1z1_31r1f = {i1zr_31r1f}
                  AND i1z1s.i1z1i1zr1k = {i1zr_key}
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
        i1z1c3100i: {
          pfx: "曜日区分",
          ls: [
            { key: 10, pfx: "平日" },
            { key: 20, pfx: "土曜" },
            { key: 30, pfx: "日祝" },
          ],
/*
          atrs: [
            {
              // 曜日の設定　＃曜日区分（追加したもののみ）
              qry: `
                UPDATE
                  i1z1s
                SET
                  i1z1c3100i = (
                    SELECT
                      CASE
                        WHEN
                          i1z1c2100i = 1 OR DATE_PART('dow', i1z1d1100s::TIMESTAMP)::NUMERIC = 0
                        THEN
                          30
                        WHEN
                          DATE_PART('dow', i1z1d1100s::TIMESTAMP)::NUMERIC = 5
                        THEN
                          20
                        ELSE
                          10
                      END
                  )
                WHERE
                  COALESCE(i1z1s._dlt,-1)<>1 AND i1z1_31r1f = {i1zr_31r1f}
                  AND i1z1s.i1z1i1zr1k = {i1zr_key}
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
        i1z1c4100i: {
          pfx: "時間帯分類",
          ls: [
            { key: 111, pfx: "１種・夏時間以外・平日" },
            { key: 112, pfx: "１種・夏時間以外・土曜" },
            { key: 113, pfx: "１種・夏時間以外・日祝" },
            { key: 121, pfx: "１種・夏時間・平日" },
            { key: 122, pfx: "１種・夏時間・土曜" },
            { key: 123, pfx: "１種・夏時間・日祝" },
            { key: 211, pfx: "２種・夏時間以外・平日" },
            { key: 212, pfx: "２種・夏時間以外・土曜" },
            { key: 213, pfx: "２種・夏時間以外・日祝" },
            { key: 221, pfx: "２種・夏時間・平日" },
            { key: 222, pfx: "２種・夏時間・土曜" },
            { key: 223, pfx: "２種・夏時間・日祝" },
          ],
/*
          atrs: [
            {
              // 開始・終了時刻の設定
              qry: `
                UPDATE
                  i1z1s
                SET
                  i1z1c4100i = (
                    SELECT
                      CASE
                        WHEN
                          i1z1t1100i = 1 AND i1z1c1100i = -1 AND i1z1c3100i = 10
                        THEN
                          111
                        WHEN
                          i1z1t1100i = 1 AND i1z1c1100i = -1 AND i1z1c3100i = 20
                        THEN
                          112
                        WHEN
                          i1z1t1100i = 1 AND i1z1c1100i = -1 AND i1z1c3100i = 30
                        THEN
                          113
                        WHEN
                          i1z1t1100i = 1 AND i1z1c1100i =  1 AND i1z1c3100i = 10
                        THEN
                          121
                        WHEN
                          i1z1t1100i = 1 AND i1z1c1100i =  1 AND i1z1c3100i = 20
                        THEN
                          122
                        WHEN
                          i1z1t1100i = 1 AND i1z1c1100i =  1 AND i1z1c3100i = 30
                        THEN
                          123
                        WHEN
                          i1z1t1100i = 2 AND i1z1c1100i = -1 AND i1z1c3100i = 10
                        THEN
                          211
                        WHEN
                          i1z1t1100i = 2 AND i1z1c1100i = -1 AND i1z1c3100i = 20
                        THEN
                          212
                        WHEN
                          i1z1t1100i = 2 AND i1z1c1100i = -1 AND i1z1c3100i = 30
                        THEN
                          213
                        WHEN
                          i1z1t1100i = 2 AND i1z1c1100i =  1 AND i1z1c3100i = 10
                        THEN
                          221
                        WHEN
                          i1z1t1100i = 2 AND i1z1c1100i =  1 AND i1z1c3100i = 20
                        THEN
                          222
                        WHEN
                          i1z1t1100i = 2 AND i1z1c1100i =  1 AND i1z1c3100i = 30
                        THEN
                          223
                        ELSE
                          -1
                      END
                  )
                WHERE
                  COALESCE(i1z1s._dlt,-1)<>1 AND i1z1_31r1f = {i1zr_31r1f}
                  AND i1z1s.i1z1i1zr1k = {i1zr_key}
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
              },
            },
          ],
*/
        },
      },
    },
  },
  i1z2: {
    // 利用設備
    v0: {
      itlz: {
        i1z2i17r1f: -1,
        i1z2m1100i: 0,
        i1z2a1100i: 0,
        i1z2a1200i: 0,
        _dlt: 1,
      },
      fldz: {
        i1z2_31r1f: {
          pfx: "所属組織",
        },
        i1z2i1zr1k: {
          pfx: "利用情報",
        },
        i1z2i17r1f: {
          pfx: "備品・駐車場",
        },
        i1z2m1100i: {
          pfx: "利用料",
        },
        i1z2a1100i: {
          pfx: "開始時刻",
        },
        i1z2a1200i: {
          pfx: "終了時刻",
        },
        i1z2a2100s: {
          pfx: "備品・駐車場表記",
        },
      },
    },
  },

  i1z3: {
    // 支払情報
    v0: {
      itlz: {
        i1z3_31r1f: -1,
        i1z3i1zr1k: -1,
        i1z3a1100s: "",
        i1z3d1100s: "",
        i1z3d2100s: "",
        i1z3m1110i: 0,
        i1z3m1120i: 0,
        i1z3m2100i: 0,
        i1z3m3100i: 0,
        i1z3m4100i: 0,
        i1z3s1100i: 0,
        i1z3s2100i: -1,
        i1z3t1100i: 0,
        i1z3t2100i: -1,
        i1z3t3100i: 10,
      },
      fldz: {
        i1z3_31r1f: {
          pfx: "所属組織",
        },
        i1z3i1zr1k: {
          pfx: "利用情報",
        },
        i1z3d1100s: {
          pfx: "支払期限",
        },
        i1z3d2100s: {
          pfx: "受領日",
        },
        i1z3m1110i: {
          pfx: "利用料合計（部屋）",
        },
        i1z3m1120i: {
          pfx: "利用料合計（備品・駐車場）",
        },
        i1z3m2100i: {
          pfx: "減免額",
        },
        i1z3m3100i: {
          pfx: "その他金額",
        },
        i1z3m4100i: {
          pfx: "支払額合計",
        },
        i1z3s1100i: {
          pfx: "支払状況",
          ls: [
            { key: -1, pfx: " " },
            { key: 0, pfx: "支払なし" },
            { key: 20, pfx: "未払い" },
            { key: 40, pfx: "支払済" },
          ],
        },
        i1z3s2100i: {
          pfx: "返金状況",
          ls: [
            //{ key: -1, pfx: '返金なし（集金あり）' },
            //{ key:  1, pfx: '返金あり（集金なし）' },
/*
            { key: -1, pfx: "返金なし（集金済）" },
            { key: 1, pfx: "返金あり（未集金）" },
*/
            { key: -1, pfx: " " }, // 未設定
            { key: 10, pfx: "集金済" },
            { key: 20, pfx: "未収金" },
            { key: 30, pfx: "返金済" },
          ],
        },
        i1z3t1100i: {
          pfx: "減免率区分",
          ls: [
            { key: 0, pfx: "なし" },
            { key: 50, pfx: "50%" },
            { key: 100, pfx: "100%" },
            { key: 999, pfx: "任意" },
          ],
        },
        i1z3t2100i: {
          pfx: "減免理由",
          ls: [
            { key: -1, pfx: " " },
            { key: 10, pfx: "A" },
            { key: 20, pfx: "B" },
            { key: 30, pfx: "C" },
            { key: 40, pfx: "D" },
          ],
        },
        i1z3t3100i: {
          pfx: "支払方法",
          ls: [
            { key: -1, pfx: " " },
            { key: 10, pfx: "窓口" },
            { key: 20, pfx: "事前" },
          ],
        },
        i1z3a1100s: {
          pfx: "その他内容",
        },
      },
    },
  },

  i1z4: {
    // 人数情報
    v0: {
      itlz: {
        i1z4_31r1f: -1,
        i1z4i1zr1k: -1,
        i1z4a1100i: 0,
        i1z4a1200i: 0,
        i1z4a2100i: 0,
        i1z4a2200i: 0,
        i1z4a2300i: 0,
        i1z4a2400i: 0,
        i1z4a2500i: 0,
        i1z4a2600i: 0,
        i1z4a2700i: 0,
        i1z4a2800i: 0,
        i1z4a2900i: 0,
        i1z4a3100i: 0,
        i1z4a3200i: 0,
        i1z4a3300i: 0,
      },
      fldz: {
        i1z4_31r1f: {
          pfx: "所属組織",
        },
        i1z4i1zr1k: {
          pfx: "利用情報",
        },
        i1z4a1100i: {
          pfx: "性別／男性",
        },
        i1z4a1200i: {
          pfx: "性別／女性",
        },
        i1z4a2100i: {
          pfx: "階層別／幼児",
        },
        i1z4a2200i: {
          pfx: "階層別／小学生",
        },
        i1z4a2300i: {
          pfx: "階層別／中学生",
        },
        i1z4a2400i: {
          pfx: "階層別／高校生",
        },
        i1z4a2500i: {
          pfx: "階層別／大学生",
        },
        i1z4a2600i: {
          pfx: "階層別／一般男性",
        },
        i1z4a2700i: {
          pfx: "階層別／一般女性",
        },
        i1z4a2800i: {
          pfx: "階層別／６５歳以上男性",
        },
        i1z4a2900i: {
          pfx: "階層別／６５歳以上女性",
        },
        i1z4a3100i: {
          pfx: "住居区分／区内",
        },
        i1z4a3200i: {
          pfx: "住居区分／区外",
        },
        i1z4a3300i: {
          pfx: "住居区分／市外",
        },
      },
    },
  },

  i1z5: {
    // 予約状況 // 履歴管理対象外
    v0: {
      itlz: {
        i1z5_31r1f: -1,
        i1z5i10r1f: -1,
        i1z5d1100s: "",
        i1z5d2100i: 0,
        i1z5d2200i: 0,
        i1z5c1100i: -1,
        i1z5c2100i: -1,
        i1z5c3100i: -1,
        i1z5i1111f: -1,
        i1z5d3100i: 0,
        i1z5d3200i: 0,
        i1z5a1100i: 0,
        i1z5a2100i: 0,
      },
      unqs: ["i1z5_31r1f", "i1z5i10r1f", "i1z5d1100s", "i1z5i1111f"],
      fldz: {
        i1z5_31r1f: {
          pfx: "所属組織",
        },
        i1z5i10r1f: {
          pfx: "部屋",
        },
        i1z5d1100s: {
          pfx: "利用日",
        },
        i1z5d2100i: {
          pfx: "夏時間開始月",
        },
        i1z5d2200i: {
          pfx: "夏時間終了月",
        },
        i1z5c1100i: {
          pfx: "夏区分",
          ls: [
            { key: 1, pfx: "対象" },
            { key: -1, pfx: "非対象" },
          ],
        },
        i1z5c2100i: {
          pfx: "祝日区分",
          ls: [
            { key: 1, pfx: "対象" },
            { key: -1, pfx: "非対象" },
          ],
        },
        i1z5c3100i: {
          pfx: "曜日区分",
          ls: [
            { key: 10, pfx: "平日" },
            { key: 20, pfx: "土曜" },
            { key: 30, pfx: "日祝" },
          ],
        },
        i1z5i1111f: {
          pfx: "時間帯",
        },
        i1z5d3100i: {
          pfx: "開始時刻",
        },
        i1z5d3200i: {
          pfx: "終了時刻",
        },
        i1z5a1100i: {
          pfx: "予約数",
          atrs: [
/*
            {
              // 集計対象の追加　指定された単体部屋＋指定された複合部屋
              qry: `
                INSERT INTO
                  i1z5s
                (
                  _dmn,
                  i1z5_31r1f,
                  i1z5i10r1f,
                  i1z5d1100s,
                  i1z5i1111f,
                  "createdAt",
                  "updatedAt"
                )
                SELECT 
                  DISTINCT
                  i1zrs._dmn,
                  i1zrs.i1zr_31r1f,
                  i1z1s.i1z1i10r1f,
                  i1zrs.i1zrd3100s,
                  i1z1s.i1z1i1111f,
                  now(),
                  now()
                FROM
                  i1zrs
                  LEFT JOIN i1z1s ON i1zrs._key = i1z1i1zr1k
                WHERE
                  COALESCE(i1zrs._dlt,-1) <> 1 AND i1zrs._vsn = i1zrs._ltt
                  AND i1zrs._fst = {i1zr_fst}
                  AND COALESCE(i1z1s._dlt,-1) <> 1
                  AND COALESCE(i1z1s.i1z1i10r1f,-1) > 0
                  AND COALESCE(i1z1s.i1z1i1111f,-1) > 0
                GROUP BY
                  i1zrs._dmn,
                  i1zrs.i1zr_31r1f,
                  i1z1s.i1z1i10r1f,
                  i1zrs.i1zrd3100s,
                  i1z1s.i1z1i1111f
                ON CONFLICT ON CONSTRAINT i1z5_unq1
                DO NOTHING
              `,
              rlcz: {
                i1zr_fst: "i1zrs._fst",
              },
            },
            {
              // 集計対象の追加　指定された単体部屋を含む複合部屋
              qry: `
                INSERT INTO
                  i1z5s
                (
                  _dmn,
                  i1z5_31r1f,
                  i1z5i10r1f,
                  i1z5d1100s,
                  i1z5i1111f,
                  "createdAt",
                  "updatedAt"
                )
                SELECT 
                  DISTINCT
                  i1zrs._dmn,
                  i1zrs.i1zr_31r1f,
                  i10rs._fst,
                  i1zrs.i1zrd3100s,
                  i1z1s.i1z1i1111f,
                  now(),
                  now()
                FROM
                  i1zrs
                  LEFT JOIN i1z1s ON i1zrs._key = i1z1i1zr1k
                  LEFT JOIN i102s ON i1z1i10r1f = i102i10r1f
                  LEFT JOIN i10rs ON i102i10r1k = i10rs._key
                WHERE
                  COALESCE(i1zrs._dlt,-1) <> 1 AND i1zrs._vsn = i1zrs._ltt
                  AND i1zrs._fst = {i1zr_fst}
                  AND COALESCE(i1z1s._dlt,-1) <> 1
                  AND COALESCE(i102s._dlt,-1) <> 1
                  AND COALESCE(i10rs._dlt,-1) <> 1 AND i10rs._vsn = i10rs._ltt
                  AND COALESCE(i10rs._fst,-1) > 0
                  AND COALESCE(i1z1s.i1z1i1111f,-1) > 0
                GROUP BY
                  i1zrs._dmn,
                  i1zrs.i1zr_31r1f,
                  i10rs._fst,
                  i1zrs.i1zrd3100s,
                  i1z1s.i1z1i1111f
                ON CONFLICT ON CONSTRAINT i1z5_unq1
                DO NOTHING
              `,
              rlcz: {
                i1zr_fst: "i1zrs._fst",
              },
            },
            {
              // 集計対象の追加　指定された複合部屋に含まれる単体部屋
              qry: `
                INSERT INTO
                  i1z5s
                (
                  _dmn,
                  i1z5_31r1f,
                  i1z5i10r1f,
                  i1z5d1100s,
                  i1z5i1111f,
                  "createdAt",
                  "updatedAt"
                )
                SELECT 
                  DISTINCT
                  i1zrs._dmn,
                  i1zrs.i1zr_31r1f,
                  i102s.i102i10r1f,
                  i1zrs.i1zrd3100s,
                  i1z1s.i1z1i1111f,
                  now(),
                  now()
                FROM
                  i1zrs
                  LEFT JOIN i1z1s ON i1zrs._key = i1z1i1zr1k
                  LEFT JOIN i10rs ON i1z1i10r1f = i10rs._fst
                  LEFT JOIN i102s ON i10rs._key = i102i10r1k
                WHERE
                  COALESCE(i1zrs._dlt,-1) <> 1 AND i1zrs._vsn = i1zrs._ltt
                  AND i1zrs._fst = {i1zr_fst}
                  AND COALESCE(i1z1s._dlt,-1) <> 1
                  AND COALESCE(i10rs._dlt,-1) <> 1 AND i10rs._vsn = i10rs._ltt
                  AND COALESCE(i102s._dlt,-1) <> 1
                  AND COALESCE(i102s.i102i10r1f,-1) > 0
                  AND COALESCE(i1z1s.i1z1i1111f,-1) > 0
                GROUP BY
                  i1zrs._dmn,
                  i1zrs.i1zr_31r1f,
                  i102s.i102i10r1f,
                  i1zrs.i1zrd3100s,
                  i1z1s.i1z1i1111f
                ON CONFLICT ON CONSTRAINT i1z5_unq1
                DO NOTHING
              `,
              rlcz: {
                i1zr_fst: "i1zrs._fst",
              },
            },
            {
              // 夏時間開始月・終了月の設定（追加したもののみ）
              qry: `
                UPDATE
                  i1z5s
                SET
                  (i1z5d2100i, i1z5d2200i) = (
                    SELECT
                      COALESCE(i11ra1100i,0), COALESCE(i11ra1200i,0)
                    FROM
                      i111s LEFT JOIN i11rs ON i111s.i111i11r1k = i11rs._key
                    WHERE
                      COALESCE(i111s._dlt,-1)<>1
                      AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
                      AND i111s._fst = i1z5s.i1z5i1111f
                      AND COALESCE(i11rs._dlt,-1)<>1
                      AND i11rs._vsn = i11rs._ltt
                      AND i11rs.i11r_31r1f = i1z5s.i1z5_31r1f
                  )
                WHERE
                  COALESCE(i1z5s._dlt,-1)<>1
                  AND i1z5s.i1z5_31r1f = {i1zr_31r1f}
                  AND i1z5s.i1z5d1100s = '{i1zrd3100s}'
                  AND i1z5s.i1z5i10r1f IN (SELECT i1z1i10r1f FROM i1z1s WHERE COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i1z1i1zr1k = {i1zr_key}) -- 部屋が変わってない前提
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
                i1zrd3100s: "i1zrs.i1zrd3100s",
              },
            },
            {
              // 夏区分の設定（追加したもののみ）
              qry: `
                UPDATE
                  i1z5s
                SET
                  i1z5c1100i = (
                    SELECT
                      CASE
                        WHEN
                          SUBSTRING(i1z5d1100s, 6, 2)::NUMERIC >= i1z5d2100i
                          AND SUBSTRING(i1z5d1100s, 6, 2)::NUMERIC <= i1z5d2200i
                        THEN
                          1
                        ELSE
                          -1
                      END
                  )
                WHERE
                  COALESCE(i1z5s._dlt,-1)<>1
                  AND i1z5s.i1z5_31r1f = {i1zr_31r1f}
                  AND i1z5s.i1z5d1100s = '{i1zrd3100s}'
                  AND i1z5s.i1z5i10r1f IN (SELECT i1z1i10r1f FROM i1z1s WHERE COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i1z1i1zr1k = {i1zr_key}) -- 部屋が変わってない前提
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
                i1zrd3100s: "i1zrs.i1zrd3100s",
              },
            },
            {
              // 曜日の設定　＃祝日区分（追加したもののみ）
              qry: `
                UPDATE
                  i1z5s
                SET
                  i1z5c2100i = (
                    SELECT
                      CASE
                        WHEN
                          EXISTS(
                            SELECT
                              *
                            FROM
                              _601s
                            WHERE
                              COALESCE(_601s._dlt,-1)<>1
                              AND _601s._icn = i1z5s.i1z5d1100s
                          )
                        THEN
                          1
                        ELSE
                          -1
                      END
                  )
                WHERE
                  COALESCE(i1z5s._dlt,-1)<>1
                  AND i1z5s.i1z5_31r1f = {i1zr_31r1f}
                  AND i1z5s.i1z5d1100s = '{i1zrd3100s}'
                  AND i1z5s.i1z5i10r1f IN (SELECT i1z1i10r1f FROM i1z1s WHERE COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i1z1i1zr1k = {i1zr_key}) -- 部屋が変わってない前提
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
                i1zrd3100s: "i1zrs.i1zrd3100s",
              },
            },
            {
              // 曜日の設定　＃曜日区分（追加したもののみ）
              qry: `
                UPDATE
                  i1z5s
                SET
                  i1z5c3100i = (
                    SELECT
                      CASE
                        WHEN
                          i1z5c2100i = 1 OR DATE_PART('dow', i1z5d1100s::TIMESTAMP)::NUMERIC = 0
                        THEN
                          30
                        WHEN
                          DATE_PART('dow', i1z5d1100s::TIMESTAMP)::NUMERIC = 6
                        THEN
                          20
                        ELSE
                          10
                      END
                  )
                WHERE
                  COALESCE(i1z5s._dlt,-1)<>1
                  AND i1z5s.i1z5_31r1f = {i1zr_31r1f}
                  AND i1z5s.i1z5d1100s = '{i1zrd3100s}'
                  AND i1z5s.i1z5i10r1f IN (SELECT i1z1i10r1f FROM i1z1s WHERE COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i1z1i1zr1k = {i1zr_key}) -- 部屋が変わってない前提
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
                i1zrd3100s: "i1zrs.i1zrd3100s",
              },
            },
            {
              // 開始・終了時刻の設定
              qry: `
                UPDATE
                  i1z5s
                SET
                  i1z5d3100i = (
                    SELECT
                      CASE
                        WHEN
                          i1z5c1100i = -1 AND i1z5c3100i = 10
                        THEN
                          i111a1111i
                        WHEN
                          i1z5c1100i = -1 AND i1z5c3100i = 20
                        THEN
                          i111a1112i
                        WHEN
                          i1z5c1100i = -1 AND i1z5c3100i = 30
                        THEN
                          i111a1113i
                        WHEN
                          i1z5c1100i =  1 AND i1z5c3100i = 10
                        THEN
                          i111a1121i
                        WHEN
                          i1z5c1100i =  1 AND i1z5c3100i = 20
                        THEN
                          i111a1122i
                        WHEN
                          i1z5c1100i =  1 AND i1z5c3100i = 30
                        THEN
                          i111a1123i
                        ELSE
                          0
                      END
                    FROM
                      i111s
                    WHERE
                      COALESCE(i111s._dlt,-1)<>1
                      AND i111s._vsn = i111s._ltt
                      AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
                      AND i111s._fst = i1z5s.i1z5i1111f
                  ),
                  i1z5d3200i = (
                    SELECT
                      CASE
                        WHEN
                          i1z5c1100i = -1 AND i1z5c3100i = 10
                        THEN
                          i111a2111i
                        WHEN
                          i1z5c1100i = -1 AND i1z5c3100i = 20
                        THEN
                          i111a2112i
                        WHEN
                          i1z5c1100i = -1 AND i1z5c3100i = 30
                        THEN
                          i111a2113i
                        WHEN
                          i1z5c1100i =  1 AND i1z5c3100i = 10
                        THEN
                          i111a2121i
                        WHEN
                          i1z5c1100i =  1 AND i1z5c3100i = 20
                        THEN
                          i111a2122i
                        WHEN
                          i1z5c1100i =  1 AND i1z5c3100i = 30
                        THEN
                          i111a2123i
                        ELSE
                          0
                      END
                    FROM
                      i111s
                    WHERE
                      COALESCE(i111s._dlt,-1)<>1
                      AND i111s._vsn = i111s._ltt
                      AND i111s.i111_31r1f = i1z5s.i1z5_31r1f
                      AND i111s._fst = i1z5s.i1z5i1111f
                  )
                WHERE
                  COALESCE(i1z5s._dlt,-1)<>1
                  AND i1z5s.i1z5_31r1f = {i1zr_31r1f}
                  AND i1z5s.i1z5d1100s = '{i1zrd3100s}'
                  AND i1z5s.i1z5i10r1f IN (SELECT i1z1i10r1f FROM i1z1s WHERE COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i1z1i1zr1k = {i1zr_key}) -- 部屋が変わってない前提
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
                i1zrd3100s: "i1zrs.i1zrd3100s",
              },
            },
*/
/*
            {
              // 予約数の更新
              // 集計対象：指定された単体部屋＋指定された複合部屋＋指定された単体部屋を含む複合部屋＋指定された複合部屋に属する単体部屋
              qry: `
                UPDATE
                  i1z5s
                SET
                  i1z5a1100i = (
                    SELECT
                      COUNT(*)
                    FROM
                      i1z1s
                      LEFT JOIN i1zrs ON i1z1s.i1z1i1zr1k = i1zrs._key
                    WHERE
                      COALESCE(i1zrs._dlt,-1) <> 1 AND i1zrs._vsn = i1zrs._ltt
                      AND i1zrs.i1zr_31r1f = i1z5s.i1z5_31r1f
                      AND i1zrs.i1zrd3100s = i1z5s.i1z5d1100s
                      AND i1zrs.i1zrs1100i >= 70
                      AND COALESCE(i1z1s._dlt,-1) <> 1
                      AND i1z1s.i1z1_31r1f = i1zrs.i1zr_31r1f
                      AND (
                        (i1z1s.i1z1i10r1f = i1z5s.i1z5i10r1f)
                        OR i1z1s.i1z1i10r1f IN (
                          SELECT 
                            _fst 
                          FROM 
                            i10rs 
                          WHERE
                            COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                            AND _key IN (
                              SELECT
                                i102i10r1k
                              FROM
                                i102s
                              WHERE
                                COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                                AND i102i10r1f = i1z5s.i1z5i10r1f
                            )
                        )
                        OR i1z1s.i1z1i10r1f IN (
                          SELECT
                            i102i10r1f
                          FROM
                            i102s
                          WHERE
                            COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                            AND i102i10r1k IN (
                              SELECT
                                _key
                              FROM
                                i10rs
                              WHERE
                                COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                                AND _fst = i1z5s.i1z5i10r1f
                            )
                        )
                      )
                      AND i1z1s.i1z1a1200i > i1z5s.i1z5d3100i
                      AND i1z1s.i1z1a1100i < i1z5s.i1z5d3200i
                  )
                WHERE
                  COALESCE(i1z5s._dlt,-1)<>1
                  AND i1z5s.i1z5_31r1f = {i1zr_31r1f}
                  AND i1z5s.i1z5d1100s IN (SELECT DISTINCT i1zrd3100s FROM i1zrs WHERE _fst = {i1zr_fst})
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_fst: "i1zrs._fst",
              },
            },
*/
            {
              // 予約数の更新
              // 集計対象：指定された単体部屋＋指定された複合部屋＋指定された単体部屋を含む複合部屋＋指定された複合部屋に属する単体部屋
              qry: `
                UPDATE
                  i1z5s
                SET
                  i1z5a1100i = (
                    SELECT
                      COUNT(*)
                    FROM
                      i1z1s
                      LEFT JOIN i1zrs ON i1z1s.i1z1i1zr1k = i1zrs._key
                    WHERE
                      COALESCE(i1zrs._dlt,-1) <> 1 AND i1zrs._vsn = i1zrs._ltt
                      AND i1zrs.i1zr_31r1f = i1z5s.i1z5_31r1f
                      AND i1zrs.i1zrd3100s = i1z5s.i1z5d1100s
                      AND i1zrs.i1zrs1100i >= 70
                      AND COALESCE(i1z1s._dlt,-1) <> 1
                      AND i1z1s.i1z1_31r1f = i1zrs.i1zr_31r1f
                      AND (
                        (i1z1s.i1z1i10r1f = i1z5s.i1z5i10r1f)
                        OR i1z1s.i1z1i10r1f IN (
                          SELECT 
                            _fst 
                          FROM 
                            i10rs 
                          WHERE
                            COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                            AND _key IN (
                              SELECT
                                i102i10r1k
                              FROM
                                i102s
                              WHERE
                                COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                                AND i102i10r1f = i1z5s.i1z5i10r1f
                            )
                        )
                        OR i1z1s.i1z1i10r1f IN (
                          SELECT
                            i102i10r1f
                          FROM
                            i102s
                          WHERE
                            COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                            AND i102i10r1k IN (
                              SELECT
                                _key
                              FROM
                                i10rs
                              WHERE
                                COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                                AND _fst = i1z5s.i1z5i10r1f
                            )
                        )
                      )
                      AND i1z1s.i1z1a1200i > i1z5s.i1z5d3100i
                      AND i1z1s.i1z1a1100i < i1z5s.i1z5d3200i
                  )
                WHERE
                  COALESCE(i1z5s._dlt,-1)<>1
                  AND i1z5s.i1z5_31r1f = {i1zr_31r1f}
                  AND i1z5s.i1z5d1100s = '{i1zrd3100s}' -- 利用日が変わってない前提
                  AND i1z5s.i1z5i10r1f IN (SELECT i1z1i10r1f FROM i1z1s WHERE COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i1z1i1zr1k = {i1zr_key}) -- 部屋が変わってない前提
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
                i1zrd3100s: "i1zrs.i1zrd3100s",
              },
            },
          ],
        },
        i1z5a2100i: {
          pfx: "エントリ数",
          atrs: [
            {
              // エントリ数の更新（予約数が更新されている前提）
              // 集計対象：指定された単体部屋＋指定された複合部屋＋指定された単体部屋を含む複合部屋
              qry: `
                UPDATE
                  i1z5s
                SET
                  i1z5a2100i = (
                    SELECT
                      COUNT(*)
                    FROM
                      i1z1s LEFT JOIN i1zrs ON i1z1s.i1z1i1zr1k = i1zrs._key
                    WHERE
                      COALESCE(i1zrs._dlt,-1)<>1
                      AND i1zrs._vsn = i1zrs._ltt
                      AND i1zrs.i1zr_31r1f = i1z5s.i1z5_31r1f
                      AND i1zrs.i1zrd3100s = i1z5s.i1z5d1100s
                      AND i1zrs.i1zrs1200i >= 70
                      AND COALESCE(i1z1s._dlt,-1)<>1
                      AND i1z1s.i1z1_31r1f = i1zrs.i1zr_31r1f
                      AND (
                        (i1z1s.i1z1i10r1f = i1z5s.i1z5i10r1f)
                        OR i1z1s.i1z1i10r1f IN (
                          SELECT 
                            _fst 
                          FROM 
                            i10rs 
                          WHERE
                            COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                            AND _key IN (
                              SELECT
                                i102i10r1k
                              FROM
                                i102s
                              WHERE
                                COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                                AND i102i10r1f = i1z5s.i1z5i10r1f
                            )
                        )
                        OR i1z1s.i1z1i10r1f IN (
                          SELECT
                            i102i10r1f
                          FROM
                            i102s
                          WHERE
                            COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i102_31r1f = i1z5s.i1z5_31r1f
                            AND i102i10r1k IN (
                              SELECT
                                _key
                              FROM
                                i10rs
                              WHERE
                                COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i10r_31r1f = i1z5s.i1z5_31r1f
                                AND _fst = i1z5s.i1z5i10r1f
                            )
                        )
                      )
                      AND i1z1s.i1z1a1200i > i1z5s.i1z5d3100i
                      AND i1z1s.i1z1a1100i < i1z5s.i1z5d3200i
                  )
                WHERE
                  COALESCE(i1z5s._dlt,-1)<>1
                  AND i1z5s.i1z5_31r1f = {i1zr_31r1f}
                  AND i1z5s.i1z5d1100s = '{i1zrd3100s}' -- 利用日が変わってない前提
                  AND i1z5s.i1z5i10r1f IN (SELECT i1z1i10r1f FROM i1z1s WHERE COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND i1z1i1zr1k = {i1zr_key}) -- 部屋が変わってない前提
              `,
              rlcz: {
                i1zr_31r1f: "i1zrs.i1zr_31r1f",
                i1zr_key: "i1zrs._key",
                i1zrd3100s: "i1zrs.i1zrd3100s",
              },
            },
          ],
        },
      },
    },
  },
};
